var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoxears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470.01 149.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2771d;}.cls-2{fill:#231f20;}.cls-3{fill:#eb9eac;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.73,294.73c-8.93-13.32-34-59.06-13.19-127.32,3.1-10.15,13.56-14.31,20.46-8.08l82.15,74.25c5.27,4.77,6.24,13.83,2.15,20.62-12,19.86-40,55.16-84.39,45.59A11.6,11.6,0,0,1,176.73,294.73Z",
    transform: "translate(-155.47 -156.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-69,119.5",
    transform: "translate(-155.47 -156.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.85,289.12c-5.83-9.85-22.11-43.75-7.07-95.18,2.24-7.65,9.36-10.92,13.92-6.35L249,242c3.49,3.49,4,10.26,1.15,15.41-8.35,15.05-27.78,41.89-57.56,35.36A7.5,7.5,0,0,1,187.85,289.12Z",
    transform: "translate(-155.47 -156.4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.21,299.53c8.93-13.32,34-59.06,13.19-127.32-3.1-10.15-13.56-14.31-20.46-8.07l-82.15,74.25c-5.27,4.76-6.24,13.82-2.15,20.61,12,19.86,40,55.16,84.39,45.6A11.68,11.68,0,0,0,604.21,299.53Z",
    transform: "translate(-155.47 -156.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M593.08,293.92c5.83-9.85,22.12-43.75,7.08-95.18-2.24-7.65-9.36-10.92-13.92-6.35L531.9,246.84c-3.49,3.49-4,10.26-1.16,15.41,8.36,15.05,27.79,41.89,57.57,35.36A7.48,7.48,0,0,0,593.08,293.92Z",
    transform: "translate(-155.47 -156.4)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.65 133.86 41.53 118.1 57.53 120.1 49.53 97.1 68.53 111.1 73.53 101.1 82.83 118.22 76.53 130.1 62.65 133.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.44,277.12l12.75-22.94L554,267.5l19.71-11.08-10,23.24,17.53-2-20.56,16.83S541.53,289.17,540.44,277.12Z",
    transform: "translate(-155.47 -156.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxears);
export default __webpack_public_path__ + "static/media/fox ears.1b8f721d.svg";
export { ForwardRef as ReactComponent };